import { $Locale } from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';
import { $HomepageEnterTraffic } from './traffic';

export const $EnablePinterest = atom((get) => {
  const { region, ipRegion } = get($Locale);
  const { href } = get($HomepageEnterTraffic);
  const EU_REGIONS = [''];

  return (
    (href.includes('pid=pinterest_int') || href.includes('pid=US_pinterest')) &&
    !EU_REGIONS.includes(region) &&
    !EU_REGIONS.includes(ipRegion)
  );
});
